import { Autocomplete, TextField, CircularProgress } from "@mui/material";
const LocationForm = ({
  formData,
  errors,
  villes,
  villages,
  handleChangeVille,
  handleChange,
  isLoading,
}) => (
  <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8">
    <Autocomplete
      id="ville"
      options={villes}
      size="small"
      fullWidth
      onChange={handleChangeVille}
      value={villes.find((v) => v.id === formData.ville_id) || null}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Zone administrative"
          error={!!errors.ville}
          helperText={errors.ville}
        />
      )}
    />
    {isLoading && <CircularProgress />}
    {villages.length > 0 && (
      <Autocomplete
        id="village"
        options={villages}
        size="small"
        fullWidth
        /*  onChange={handleChangeVillage} */
        onChange={(_, value) => handleChange("village_id", value?.id || "")}
        value={villages.find((v) => v.id === formData.village_id) || null}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Localité"
            error={!!errors.village}
            helperText={errors.village}
          />
        )}
      />
    )}
  </div>
);

export default LocationForm;
